import React from 'react';
import { Box, Grid, Typography, Card, CardContent, CardHeader, Chip } from '@mui/material';
import { useEffect, useState, useMemo } from 'react';

import { PermissionUserCard } from '../../components/Permissions/PermissionUserCard';
// import { PermissionUserCard } from "./PermissionUserCard";

const CustomersPermissions = props => {
  const selectedUser = props.selectedUser;
  const assignedCustomersIds = selectedUser.cust_ids;
  const availableCustomers = props.allUsers.filter(u => u.role === 'c');
  // const assignedSet = new Set(assignedCustomersIds.map(Number));

  const handleAssignCustomer = custId => {
    const id = Number(custId);

    // find the customer first (prefer the notAssigned list; fall back to the global list)
    const candidate =
      props.notAssignedCustomersInfo.find(c => Number(c.id) === id) ||
      availableCustomers.find(c => Number(c.id) === id);

    if (!candidate) return; // nothing to do

    // add to assigned (no duplicates)
    props.setAssignedCustomersInfo(prev => (prev.some(c => Number(c.id) === id) ? prev : [...prev, candidate]));

    // remove from notAssigned
    props.setNotAssignedCustomersInfo(prev => prev.filter(c => Number(c.id) !== id));
  };

  const handleUnassignCustomer = custId => {
    const id = Number(custId);

    // find the customer first (prefer the notAssigned list; fall back to the global list)
    const candidate =
      props.notAssignedCustomersInfo.find(c => Number(c.id) === id) ||
      availableCustomers.find(c => Number(c.id) === id);

    if (!candidate) return; // nothing to do

    // add to assigned (no duplicates)
    props.setNotAssignedCustomersInfo(prev => (prev.some(c => Number(c.id) === id) ? prev : [...prev, candidate]));

    // remove from notAssigned
    props.setAssignedCustomersInfo(prev => prev.filter(c => Number(c.id) !== id));
  };
  return (
    <>
      {/* ASSIGNED CUSTOMERS SECTION */}
      <Grid item xs={12} md={6}>
        <Card>
          <CardHeader
            title={`Assigned Customers (${assignedCustomersIds.length})`}
            sx={{
              bgcolor: 'success.main',
              '& .MuiCardHeader-title': { color: '#ffffff' },
            }}
          />
          <CardContent
            sx={{
              minHeight: '400px',
              maxHeight: '600px',
              overflow: 'auto',
            }}>
            {props.assignedCustomersInfo.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body2" color="text.secondary">
                  No customers assigned to this user
                </Typography>
              </Box>
            ) : (
              <Grid container spacing={2}>
                {props.assignedCustomersInfo.map(c => {
                  let custAreasCount = c.building_permissions.reduce(
                    (sum, x) => sum + (Array.isArray(x.floor_and_area_ids) ? x.floor_and_area_ids.length : 0),
                    0,
                  );
                  return (
                    <Grid item xs={12} key={c.id}>
                      <Box
                        sx={{
                          cursor: 'pointer',
                          '&:hover': {
                            transform: 'scale(1.02)',
                            transition: 'transform 0.2s ease-in-out',
                          },
                          transition: 'transform 0.2s ease-in-out',
                          position: 'relative',
                        }}
                        onClick={() => handleUnassignCustomer(c.id)}>
                        <PermissionUserCard
                          className="permissionUserCard"
                          id={c.id}
                          username={c.username}
                          role={c.role}
                          roleDisplay={c.role_display}
                          buildingNames={c.building_names}
                          totalAreas={custAreasCount}
                          customerCount={c.customerCount}
                          customerNames={c.customerNames}
                          cardClickInfo="Click to remove"
                        />
                        {/* Area restrictions indicator */}
                        <Chip
                          label="Full Access"
                          size="small"
                          color="success"
                          sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            fontSize: '0.75rem',
                          }}
                        />
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </CardContent>
        </Card>
      </Grid>

      {/* AVAILABLE CUSTOMERS SECTION */}
      <Grid item xs={12} md={6}>
        <Card>
          <CardHeader
            title={`Available Customers (${props.notAssignedCustomersInfo.length})`}
            sx={{
              bgcolor: 'primary.main',
              '& .MuiCardHeader-title': { color: '#ffffff' },
            }}
          />
          <CardContent
            sx={{
              minHeight: '400px',
              maxHeight: '600px',
              overflow: 'auto',
            }}>
            {props.notAssignedCustomersInfo.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body2" color="text.secondary"></Typography>
              </Box>
            ) : (
              <Grid container spacing={2}>
                {props.notAssignedCustomersInfo.map(c => {
                  console.log('c:', c);
                  let custAreasCount = c.building_permissions.reduce(
                    (sum, x) => sum + (Array.isArray(x.floor_and_area_ids) ? x.floor_and_area_ids.length : 0),
                    0,
                  );
                  return (
                    <Grid item xs={12} key={c.id}>
                      <Box
                        sx={{
                          cursor: 'pointer',
                          '&:hover': {
                            transform: 'scale(1.02)',
                            transition: 'transform 0.2s ease-in-out',
                          },
                          transition: 'transform 0.2s ease-in-out',
                        }}
                        onClick={() => handleAssignCustomer(c.id)}>
                        <PermissionUserCard
                          className="permissionUserCard"
                          id={c.id}
                          username={c.username}
                          role={c.role}
                          roleDisplay={c.role_display}
                          buildingNames={c.building_names}
                          totalAreas={custAreasCount}
                          customerCount={c.customerCount}
                          customerNames={c.customerNames}
                          cardClickInfo="Click to add"
                        />
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

export default CustomersPermissions;
